/**
 * Énum des contextes de référentiel
 */
export enum ContexteReferentiel {
	PRESTATION = "PRESTATION",
	UTILISATEUR = "UTILISATEUR",
	VEHICULE = "VEHICULE"
}